import { RedirectAttrs } from './models/commonModels';

export const getUrlVars = (searchQuery: string): RedirectAttrs => {
    const hashes = searchQuery.slice(searchQuery.indexOf('?') + 1).split('&');
    if (hashes.length > 1 || !hashes.includes('')) {
        return hashes.reduce((redirectInfo, hash) => {
            const attr = hash.split(/=(.+)/);
            return { ...redirectInfo, [attr[0]]: attr[1] };
        }, {});
    }
    return {};
};
export const getQueryParameter = (key: string): string => {
    if (getUrlVars(window.location.search)[key]) {
        return getUrlVars(window.location.search)[key];
    }
    return '';
};
